import { TimeTracker } from "app/containers/Features/components/TimeTracker";
import { actions as homeActions } from "app/containers/Features/containers/Home/redux/slice";
import { IDashboardUserTicket } from "app/containers/Features/containers/Home/type";
import React, { FC, ReactNode, useState } from "react";
import { useDispatch } from "react-redux";

export const TimeTrackerTrigger: FC<{
  children: ReactNode;
  row: IDashboardUserTicket;
}> = ({ children, row }) => {
  // Hooks
  const dispatch = useDispatch();

  // Local States
  const [menuVisibility, setMenuVisibility] = useState<boolean>(false);

  return (
    <TimeTracker
      needToFetchMembers
      menuVisibility={menuVisibility}
      onOpenChange={(open) => setMenuVisibility(open)}
      assigneeId={""}
      tooltipText={""}
      portalProps={{
        hideTimerStartIcon: true,
        totalEffortActual: row?.totalEffortActual,
        effortActual: row?.effortActual,
        selectedTicketDetails: {
          _id: row?._id,
          projectId: row?.projectId,
          ticketName: row?.title,
        },
        callback({ form, response }) {
          setMenuVisibility(false);
          dispatch(
            homeActions.addEffortActualEntryLocally({
              ticketId: form?.selectedTicketDetails?._id,
              entry: response,
            }),
          );
        },
      }}
    >
      {children}
    </TimeTracker>
  );
};
